<p-dialog header="{{dialogTitle}}" [(visible)]="displayDialog" [modal]="true" [style]="{width: '250px', hight:'350px' }"
    [closable]="false" [resizable]="false" [draggable]="false" [dismissableMask]="true"
    >
    <div class="p-fluid">
        <div class="p-d-flex p-jc-between p-ai-center p-mb-3">
            <div class="p-field p-mr-2" style="flex: 1;">
                <input pInputText id="from" type="number" placeholder="From" [(ngModel)]="filter.from"
                    [ngModelOptions]="{standalone: true}" (ngModelChange)="onFromChange($event)">
            </div>
            <div class="p-field" style="flex: 1;">
                <input pInputText id="to" type="number" placeholder="To" [(ngModel)]="filter.to"
                    [ngModelOptions]="{standalone: true}" (ngModelChange)="onToChange($event)">
            </div>
        </div>

        <div class="p-col-12 slider-padding">
            <p-slider [(ngModel)]="rangeValues" [min]="minValue" [max]="maxValue" [range]="true"
                (onChange)="handleChange($event)">
            </p-slider>
        </div>


        <div class="p-col-12 p-d-flex p-jc-end p-ai-center">
            <button pButton type="button" label="Reset" icon="pi pi-times" class="p-button-secondary p-mr-2"
                (click)="resetFilter()"></button>
            &nbsp;&nbsp;
            <button pButton type="button" label="Apply" icon="pi pi-check" class="p-button-primary"
                (click)="applyFilter()"></button>
        </div>
    </div>
</p-dialog>